module.exports = __webpack_public_path__ + "img/round-tag.7f846cd5.svg";